import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Avatar({ m }) {
  const [broken, setBroken] = useState(false);
  if (m.photo_url && !broken) {
    return (
      <img
        src={m.photo_url}
        alt={m.name}
        onError={() => setBroken(true)}
        className="h-20 w-20 rounded-full object-cover ring-2 ring-amber-300/30"
      />
    );
  }
  return (
    <span className="grid h-20 w-20 place-items-center rounded-full bg-amber-300/20 text-xl font-bold text-amber-200">
      {(m.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("")}
    </span>
  );
}

export default function MeetTheTeam() {
  const [team, setTeam] = useState([]);
  useEffect(() => {
    axios.get(`${API}/team`).then(({ data }) => setTeam(data || [])).catch(() => setTeam([]));
  }, []);
  if (!team.length) return null;
  return (
    <div className="mt-7" data-testid="meet-the-team">
      <p className="mb-1 font-mono text-[11px] uppercase tracking-[0.2em] text-amber-400/90">Meet the team</p>
      <p className="mb-3 text-[13px] text-slate-300">The people who guide you — experience, personal attention and careful coordination at every stage.</p>
      <div className="grid grid-cols-2 gap-3">
        {team.map((m) => (
          <div key={m.name} data-testid={`team-member-${m.name.replace(/\s/g, "-").toLowerCase()}`}
            className="flex flex-col items-center rounded-2xl border border-white/[0.07] bg-white/[0.03] p-4 text-center">
            <Avatar m={m} />
            <h3 className="mt-3 text-sm font-semibold text-white">{m.name}</h3>
            <p className="mt-0.5 text-[11px] leading-snug text-slate-400">{m.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
